import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy, } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from 'src/app/_services/Customer/customer.service';
import { NewChallan } from 'src/app/Entites/Challan/challan';
import { ChallanService } from 'src/app/_services/Challan/challan.service';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { ToastrService } from 'ngx-toastr';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductItemService } from 'src/app/_services/productItem/product-item.service';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-addchallan',
  templateUrl: './addchallan.component.html',
  styleUrls: ['./addchallan.component.css'],
  providers: [Dateconfig, CustomLoaderCComponent]
})
export class AddchallanComponent implements OnInit, OnDestroy {

  @ViewChild('ng-select') ngSelect;
  @BlockUI('singleSelect') blockUISingleSelect: NgBlockUI;
  @BlockUI('multipleSelect') blockUIMultipleSelect: NgBlockUI;
  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @Output() closeModalEvent = new EventEmitter<boolean>();
  allCustomers?: Subscription
  getChallan?: Subscription
  /**
    *
    * @param NgbModal      modal
    */
  public customerarray;
  NewChallan = new NewChallan()
  model: any = {};
  model1: any = {};
  rows1: any;
  rows: any;
  temp: any;
  public challanItems = [];
  public breadcrumb: any;
  options = {
    close: false,
    expand: true,
    minimize: true,
    reload: false
  };
  loading = false;
  submitted = false;
  f: NgForm;
  f1: NgForm;

  customermodel: any = {}
  idChallan: string;
  showcustomer: boolean = false;
  booleanvalue: boolean = false;
  public showCustomerdetails: boolean = false;
  public isgst: boolean = false;
  public maxdate;
  public UserTypeDescription: string;
  public idLoggedInEmployee: number;


  constructor(
    private CustomerService: CustomerService,
    private ChallanService: ChallanService,
    private router: ActivatedRoute,
    private routernav: Router,
    private modalpop: NgbModal,
    private dateconfig: Dateconfig,
    private spinner: CustomLoaderCComponent,
    private toastrService: ToastrService,
    private productItemService: ProductItemService

  ) {
      this.UserTypeDescription = localStorage.getItem(LocalStorageConstants.USER_TYPE_DESCRIPTION);
      this.idLoggedInEmployee = Number(localStorage.getItem(LocalStorageConstants.ID));
   }

  public customer: any = {}

  ngOnInit() {
    this.model.challanContactNo = "8686480808";
    this.spinner.showSpinner();
    this.maxdate = this.dateconfig.getcurrentdate();

    this.allCustomers = this.CustomerService.GetAllCustomer().subscribe(response => {
      this.customerarray = response ?? [];
      this.rows = response ?? [];
      this.spinner.hideSpinner();
    });

    this.idChallan = this.router.snapshot.queryParamMap.get('Id');
    this.customer = this.router.snapshot.queryParamMap.get('customer');
    this.idChallan = atob(this.idChallan);

    if (Number(this.idChallan) > 0) {
      this.loadChallanForUpdate();
    } else {
      this.prepareNewChallan();
    }
  }

  private loadChallanForUpdate() {
    this.spinner.showSpinner();
    document.title = 'Update Challan';
    this.breadcrumb = { mainlabel: 'Update Challan' };
    this.showcustomer = true;
    this.showCustomerdetails = true;
    this.booleanvalue = true;

    this.getChallan = this.ChallanService.getbyidchallan(Number(this.idChallan)).subscribe(response => {
      this.rows = response;
      this.temp = response;
      this.model = response;
      this.model.challanDate = this.dateconfig.getshortdate(this.model.challanDate);

      this.customermodel = {
        customerAddress: this.model.customerAddress,
        customerEmail: this.model.customerEmail,
        customerFirstName: this.model.customerFirstName,
        customerFullName: this.model.customerFullName,
        customerGSTNO: this.model.customerGSTNO,
        idCustomer: this.model.idCustomer
      };
      this.bindformcustomer(this.customermodel);

      if (this.rows.lstChallanItems == null) {
        this.AddForm();
      } else {
        this.challanItems = this.rows.lstChallanItems;
      }
      this.spinner.hideSpinner();
    });
  }

  private prepareNewChallan() {
    this.AddForm();
    this.model.challanDate = this.dateconfig.getcurrentdate();
    this.breadcrumb = { mainlabel: 'Add Challan' };
  }

  ngOnDestroy(): void {
    this.getChallan?.unsubscribe();
    this.allCustomers?.unsubscribe();
  }

  bindformcustomer(selectcustomerdata: any) {
    this.showcustomer = false;
    if (!selectcustomerdata) {
      this.cancel();
    } else {
      this.customermodel = selectcustomerdata;
      this.model.selectcustomer = selectcustomerdata;
      this.showcustomer = true;
    }
  }

  AddForm() {
    const newChallan = new NewChallan();
    newChallan.challanItemQty = 1;
    this.challanItems.push(newChallan);
  }

  RemoveForm(index: number) {
    if (this.challanItems[index]) {
      this.challanItems[index].operationState = "d";
    }
  }

  cancel() {
    if (Number(this.idChallan) > 0) {
      this.routernav.navigate(['/challan/allchallan']);
    }
    this.showcustomer = false;
    this.showCustomerdetails = false;
    this.model = {};
    this.customermodel = {};
    this.modalpop.dismissAll();
    this.challanItems = [];
    this.model.challanDate = this.dateconfig.getcurrentdate();
    this.model.challanContactNo = "8686480808";
  }

  savechallan(isValid: boolean) {
    if (!isValid) return;
    this.spinner.showSpinner();

    if (Number(this.idChallan) < 0 || this.idChallan == "ée") {
      this.challanItems = this.challanItems.filter(item => item.operationState !== "d");
      this.model.lstChallanItems = this.challanItems;
      this.model.idCustomer = this.model.selectcustomer.idCustomer;
      this.model.createdBy = this.idLoggedInEmployee;
      this.ChallanService.savechallan(this.model).subscribe(
        res => this.handleChallanResponse(res, true),
        () => this.handleChallanError()
      );
    } else if (Number(this.idChallan) > 0) {
      this.challanItems = this.challanItems.filter(item => !(item.idChallanItem === undefined && item.operationState === "d"));
      this.model.lstChallanItems = this.challanItems;
      this.model.modifiedBy = this.idLoggedInEmployee;
      this.model.idCustomer = this.model.selectcustomer.idCustomer;
      this.ChallanService.updatechallan(this.model).subscribe(
        res => this.handleChallanResponse(res, false),
        () => this.handleChallanError()
      );
    }
  }

  private handleChallanResponse(res: any, isNew: boolean) {
    this.spinner.hideSpinner();
    if (res.result == 1) {
      this.toastrService.success(res.userMessage, 'Success!', { timeOut: 2000, closeButton: true });
      window.open('/viewchallan?Id=' + btoa(res.idChallan), '_blank');
      this.cancel();
      this.routernav.navigate(['/challan/allchallan']);
    } else {
      this.toastrService.error(res.userMessage, 'Error!', { timeOut: 3000, closeButton: true });
    }
  }

  private handleChallanError() {
    this.spinner.hideSpinner();
    this.toastrService.error('Something went wrong!', 'Error!', { timeOut: 3000, closeButton: true });
  }

  SaveCustomer(isValid: boolean) {
    if (!isValid || this.model.idCustomer !== undefined) return;
    this.spinner.showSpinner();
    this.model.createdBy = this.idLoggedInEmployee;
    this.CustomerService.savecustomer(this.model).subscribe(
      (res: any) => {
        this.spinner.hideSpinner();
        if (res.result == 1) {
          this.cancel();
          this.customerarray.push(res);
          this.bindformcustomer(res);
          this.customerarray = [this.customerarray];
          this.toastrService.success(res.userMessage, 'Success!', { timeOut: 2000, closeButton: true });
        } else {
          this.toastrService.error(res.userMessage, 'Error!', { timeOut: 3000, closeButton: true });
        }
      },
      () => {
        this.spinner.hideSpinner();
        this.toastrService.error('Something went wrong!', 'Error!', { timeOut: 3000, closeButton: true });
      }
    );
  }

  addcustomer(model: any) {
    this.model.action = "Add Customer";
    this.modalpop.open(this.modalContent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }

  updateOperationState(index: number) {
    const item = this.challanItems[index];
    if (item?.idChallanItem !== undefined) {
      item.operationState = "u";
    }
  }

  onScan(index: number) {
    this.spinner.showSpinner();
    const item = this.challanItems[index];
    this.productItemService.GetProductItemByBarCode(item.challanItemQrCode).subscribe({
      next: (response) => {
        if (response) {
          item.challanItemQrCode = response.productItemBarCode;
          item.challanItemNameDes = response.productItemDescription;
          item.challanItemSerialNo = response.productItemSerialNo;
          this.challanItems = [...this.challanItems];
        } else {
          this.toastrService.warning("Barcode doesn't exist or sold out.", 'Validation!', { timeOut: 3000, closeButton: true });
        }
        this.spinner.hideSpinner();
      },
      error: () => {
        this.spinner.hideSpinner();
        this.toastrService.error('Error scanning barcode.', 'Error!', { timeOut: 3000, closeButton: true });
      }
    });
  }
}
